import React, { ComponentProps, ComponentType, JSXElementConstructor } from 'react';
import cx from 'classnames';
import { camelCase } from 'lodash';
import * as styles from './Text.module.scss';

export enum TextScale {
  Display = 'display',
  Headline = 'headline',
  Body = 'body',
}

type Props<TComponentType extends JSXElementConstructor<any>> =
  ComponentProps<TComponentType> & {
    as?: ComponentType;
    scale: TextScale;
    level?: 1 | 2 | 3 | 4 | 5;
  };

const Text = <TComponentType extends JSXElementConstructor<any>>({
  as: Component = 'span',
  scale = TextScale.Body,
  level = 1,
  children,
  ...props
}: Props<TComponentType>) => (
  <Component
    {...props}
    className={cx(styles[camelCase(`${scale}-${level}`)], props.className)}
  >
    {children}
  </Component>
);

export default Text;
